import { createThunkRoutine } from 'redux-thunk-routine';
import {
  FETCH_USER_IDENTIFICATIONS,
  FETCH_APPLICATIONS,
  FETCH_CLIENT_SCOPES,
  FETCH_CLIENT_API_KEYS,
} from './action-types';
import type { IApiKey, IApplication, IUserIdentifications } from './interfaces';

export const FetchUserIdentificationsRoutine = createThunkRoutine<IUserIdentifications>(FETCH_USER_IDENTIFICATIONS);
export const FetchApplicationsRoutine = createThunkRoutine<IApplication[]>(FETCH_APPLICATIONS);
export const FetchClientScopesRoutine = createThunkRoutine<string[]>(FETCH_CLIENT_SCOPES);
export const FetchClientAPIKeysRoutine = createThunkRoutine<IApiKey[]>(FETCH_CLIENT_API_KEYS);
